<template lang="pug">
	div
		v-img.mb-6.text-center.py-3(v-if="showMapButton" :src="require('~/assets/images/static-map-large.jpg')")
			v-btn.text-none(small color="accent" depressed @click.prevent="$emit('map-button-click')") {{$t('accommodations-filters.button_show_map')}}

		v-card.mb-6.pb-2(outlined v-if="!hideCountries")
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('areas-filters.heading.countries')}}
			v-list(nav dense)
				v-list-item-group(v-model="countries" multiple)
					list-checkbox(v-for="(country, index) in visibleCountries" :value="country.countryCode" :key="country.countryCode")
						img.flag(:src="`https://cdn.wintersporters.com/static/images/flags/svg/${country.countryCode}.svg`" :alt="country.name" width="16")
						| {{country.name}}
				v-list-item(v-if="$store.state.countries.length > visibleCountries.length" @click.prevent="showAllCountries = true")
					v-list-item-action.mr-2.my-0
						v-icon keyboard_arrow_down
					v-list-item-content
						v-list-item-title.primary--text {{$t('navigation-default:show.all.countries')}}


		v-card.mb-6.pb-2(outlined)
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('areas-filters.heading.areas')}}
			v-list(nav dense)
				v-list-item-group(v-model="features" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.area_themes')}}
					list-checkbox(value="beginners") {{$t('areas-filters.beginners')}}
					list-checkbox(value="advanced") {{$t('areas-filters.advanced')}}
					list-checkbox(value="offpiste") {{$t('areas-filters.offpiste')}}
					list-checkbox(value="pistes") {{$t('areas-filters.pistes')}}
					list-checkbox(value="crowd") {{$t('areas-filters.crowd')}}
					list-checkbox(value="tours") {{$t('areas-filters.tours')}}
					list-checkbox(value="snowguarantee") {{$t('areas-filters.snowguarantee')}}

				v-list-item-group(v-model="sizes" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.area_size')}}
					list-checkbox(value="s") {{$t('areas-filters.small')}}
					list-checkbox(value="m") {{$t('areas-filters.medium')}}
					list-checkbox(value="l") {{$t('areas-filters.large')}}
					list-checkbox(value="xl") {{$t('areas-filters.extralarge')}}

				v-list-item-group(v-model="pistes" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.pistes')}}
					list-checkbox(value="isEasy") {{$t('areas-filters.easy')}}
					list-checkbox(value="isDifficult") {{$t('areas-filters.difficult')}}
					list-checkbox(value="hasConnectedSlopes") {{$t('areas-filters.connectedslopes')}}
					list-checkbox(value="hasNoFlatAreas") {{$t('areas-filters.noflatareas')}}
					list-checkbox(value="hasDownHill") {{$t('areas-filters.downhill')}}

				v-list-item-group(v-model="elevation")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.elevation')}}
					list-checkbox(:value="2000") {{$t('areas-filters.min2000')}}
					list-checkbox(:value="2500") {{$t('areas-filters.min2500')}}
					list-checkbox(:value="3000") {{$t('areas-filters.min3000')}}
				v-list-item-group(v-model="pistes" multiple)
					list-checkbox(value="hasSummerSkiing") {{$t('areas-filters.summerski')}}

				v-list-item-group(v-model="rating")
					v-subheader.font-weight-bold.body-2 Beoordeling
					list-checkbox(:value="3")
						v-rating(:value="3" readonly dense size="18" color="#ffb400" background-color="#ffb400")
					list-checkbox(:value="4")
						v-rating(:value="4" readonly dense size="18" color="#ffb400" background-color="#ffb400")
					list-checkbox(:value="5")
						v-rating(:value="5" readonly dense size="18" color="#ffb400" background-color="#ffb400")

		v-card.mb-6.pb-2(outlined)
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('areas-filters.heading.resorts')}}
			v-list(nav dense)
				v-list-item-group(v-model="features" multiple)
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.resort_themes')}}
					list-checkbox(value="authentic") {{$t('areas-filters.authentic')}}
					list-checkbox(value="location") {{$t('areas-filters.location')}}
					list-checkbox(value="kids") {{$t('areas-filters.kids')}}
					list-checkbox(value="apresski") {{$t('areas-filters.apresski')}}
					list-checkbox(value="price") {{$t('areas-filters.price')}}

		v-card.mb-6.pb-2(outlined)
			v-toolbar.white--text(color="primary" flat height="30px")
				v-toolbar-title.body-1.font-weight-bold {{$t('areas-filters.heading.distance')}}
			v-list(nav dense)
				v-list-item-group(v-model="distanceUtrecht" v-if="$i18n.locale === 'nl-NL'")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_city', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
					list-checkbox(:value="700") {{$t('areas-filters.distance_700')}}
					list-checkbox(:value="900") {{$t('areas-filters.distance_900')}}
					list-checkbox(:value="1000") {{$t('areas-filters.distance_1000')}}

				v-list-item-group(v-model="distanceBrussel" v-if="$i18n.locale === 'nl-BE'")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_city', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
					list-checkbox(:value="700") {{$t('areas-filters.distance_700')}}
					list-checkbox(:value="900") {{$t('areas-filters.distance_900')}}
					list-checkbox(:value="1000") {{$t('areas-filters.distance_1000')}}

				v-list-item-group(v-model="distanceHighway")
					v-subheader.font-weight-bold.body-2 {{$t('areas-filters.heading.distance_highway')}}
					list-checkbox(:value="25") {{$t('areas-filters.distance_highway_25')}}
					list-checkbox(:value="50") {{$t('areas-filters.distance_highway_50')}}
					list-checkbox(:value="100") {{$t('areas-filters.distance_highway_100')}}

</template>

<script>
import {
	VListItem,
	VListItemTitle,
	VListItemAction,
	VListItemContent,
	VCheckbox
} from 'vuetify/lib';

const {
	encodeFilters,
	decodeFilters
} = require('@dengl/common/utils/filterstrings');

const ListCheckbox = {
	render(createElement) {
		const content = createElement(VListItemContent, [
			createElement(VListItemTitle, this.$slots.default)
		]);
		return createElement(VListItem, {
			style: 'min-height:0',
			attrs: this.$attrs,
			props: { color: 'primary' },
			on: this.$listeners,
			scopedSlots: {
				default: ({ active }) => {
					const checkbox = createElement(
						VListItemAction,
						{ class: 'mr-2 my-0' },
						[
							createElement(VCheckbox, {
								props: {
									inputValue: active,
									trueValue: this.$attrs.value,
									dense: true
								}
							})
						]
					);

					return [checkbox, content];
				}
			}
		});
	}
};

export default {
	components: {
		ListCheckbox
	},
	props: {
		value: {
			type: String,
			required: true
		},
		hideCountries: {
			type: Boolean,
			default: false
		},
		showMapButton: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			elevation: null,
			rating: null,
			distanceUtrecht: null,
			distanceBrussel: null,
			distanceHighway: null,
			pistes: [],
			features: [],
			countries: [],
			sizes: [],
			showAllCountries: false
		};
	},
	computed: {
		visibleCountries() {
			return this.$store.state.countries.filter((country, index) => {
				return (
					index < 5 ||
					this.showAllCountries ||
					this.countries.includes(country.countryCode) ||
					this.$store.state.countries.length < 7
				);
			});
		},
		filters() {
			return {
				elevation: this.elevation,
				rating: this.rating,
				distanceUtrecht: this.distanceUtrecht,
				distanceBrussel: this.distanceBrussel,
				distanceHighway: this.distanceHighway,
				features: this.features,
				countries: this.countries,
				sizes: this.sizes,
				pistes: this.pistes
			};
		},
		filterstring() {
			return encodeFilters(this.filters, this.$i18n.locale);
		}
	},
	watch: {
		filterstring: {
			deep: true,
			handler(val) {
				this.$emit('input', val);
			}
		},
		value() {
			this.decodeValue();
		}
	},
	created() {
		this.decodeValue();
	},
	methods: {
		decodeValue() {
			const filters = decodeFilters(this.value, this.$i18n.locale);
			this.booleanFilters = [];
			for (const [filter, value] of Object.entries(filters)) {
				if (value === true) {
					this.booleanFilters.push(filter);
				} else {
					this[filter] = value;
				}
			}
		}
	}
};
</script>
